import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { DateTime } from 'luxon';
import { dateUtils } from 'utils';

export default (isServiceRequest) => {
  const { startDateTime, endDateTime } = useMemo(
    () => ({
      startDateTime: DateTime.fromJSDate(dateUtils.today()).minus({ years: 1 }).toString('t'),
      endDateTime: DateTime.fromJSDate(dateUtils.today()).plus({ days: 1 }).toString('t'),
    }),
    [],
  );
  const { data, isLoading, isSuccess } = useQuery([
    'GET',
    `/apis/v2/patient/bookings/recent_healthcare_services`,
    {
      startDateTime,
      endDateTime,
      isRebookingEnabled: true,
      requestService: isServiceRequest,
    },
  ]);

  const options = useMemo(
    () =>
      data?.data.map((x) => ({
        id: x.id,
        name: x.attributes.name,
        description: x.attributes.description,
        duration: x.attributes.durationMinute,
      })),
    [data],
  );

  return { data: options || [], isLoading, isFetching: isLoading, isSuccess };
};
